module.exports = __webpack_public_path__ + "img/icon_02.60584a5.png";